module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-fixed l-height-100 sidebar"
  }, [_c('a', {
    staticClass: "sidebar-toggle",
    on: {
      "click": function($event) {
        return _vm.toggleSidebar()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons sidebar-menu-icon"
  }, [_vm._v("menu")]), _vm._v(" "), _c('i', {
    staticClass: "material-icons sidebar-close-icon"
  }, [_vm._v("close")]), _vm._v(" "), _c('span', [_vm._v("Hide Sidebar")])]), _vm._v(" "), _c('Navigation'), _vm._v(" "), _c('Contact')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d6f55dec"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar.vue
// module id = 454
// module chunks = 1